// This function allows verifying that all switch or type cases were covered.
// TypeScript will produce an error in this case.
// https://stackoverflow.com/questions/39419170/how-do-i-check-that-a-switch-block-is-exhaustive-in-typescript
export default function assertUnreachable(_x: never): never {
  throw new Error('This statement must not be reached')
}
